import React from 'react'
import { GlassesIcon, DownloadIcon } from '../utils/icons'
import './CatalogComponent.scss'

export const CatalogComponent = ({ catalog }) => {
    return (
        <div className="catalog-container">
            <div className="img">
                <img src={catalog.hrefImage} onError={(e) => {
                    e.target.onerror = null
                    e.target.src = '/static/img/no-imagen-fansa.png'
                }} alt="" />
            </div>
            <div className="title">
                <p>{catalog.title}</p>
            </div>
            <div className="show">
                <div className="icon">
                    <GlassesIcon size={30} />
                </div>
                <div className="text">
                    <a href={catalog.hrefFile} target="_blank">Ver catálogo online</a>
                </div>
            </div>
            <div className="download">
                <div className="icon">
                    <DownloadIcon size={20} />
                </div>
                <div className="text">
                    <a href={catalog.hrefFile} download>Descargar PDF</a>
                </div>
            </div>
        </div>
    )
}
